import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateVehicleMakeForm from '../../../modules/vehicleMakes/components/CreateVehicleMakeForm';
import { useParams } from 'react-router-dom';

const CreateVehicleMake = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const title = id ? t('edit_vehicle_make') : t('create_vehicle_make');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/vehicle-makes/create-vehicle-make' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateVehicleMakeForm />
    </div>
  );
};

export default CreateVehicleMake;
